module.exports = __webpack_public_path__ + "img/add.4aa971d6.svg";